import React from 'react';
import { layoutConfig } from './citiesData';
import SafeIcon from '../../common/SafeIcon';

const MailerCard = ({ city, side, reservedSlots, onSlotClick }) => {
  const slots = layoutConfig[side];

  const renderSlot = (slotId) => {
    const slot = slots.find(s => s.id === slotId);
    if (!slot) return null;

    const fullId = `${city.id}-${side}-${slot.id}`;
    const isReserved = reservedSlots[fullId];

    if (isReserved) {
      return (
        <div className="w-full h-full bg-[#e5e5e5] border-2 border-solid border-[#cccccc] rounded flex flex-col items-center justify-center p-2 text-center relative overflow-hidden">
          <span className="font-display text-lg md:text-xl uppercase tracking-tighter text-gray-400 line-through z-10">{slot.type}</span>
          <div className="absolute inset-0 flex items-center justify-center z-20">
            <span className="font-display text-sm md:text-lg text-red-600 border-4 border-red-600 rounded px-2 py-1 bg-white/95 transform -rotate-12 shadow-md">
              RESERVED
            </span>
          </div>
        </div>
      );
    }

    return (
      <div 
        onClick={() => onSlotClick({ id: fullId, ...slot, cityName: city.name })}
        className="w-full h-full bg-[#fdfbf6] border-2 border-dashed border-retro-brown/40 rounded flex flex-col items-center justify-center p-2 text-center hover:bg-white hover:border-retro-blue hover:shadow-retro-sm cursor-pointer transition-all group relative"
      >
        <span className="font-display text-lg md:text-2xl uppercase tracking-tighter text-retro-brown group-hover:text-retro-blue transition-colors leading-none mb-1">
          {slot.type}
        </span>
        <span className="font-body text-[10px] md:text-xs font-bold text-gray-400 mb-2">
          {slot.size}
        </span>
        <div className="font-body text-[8px] md:text-[10px] font-bold text-gray-500 group-hover:text-retro-brown bg-gray-100 group-hover:bg-retro-yellow px-2 py-1 rounded border border-transparent group-hover:border-retro-brown transition-all uppercase">
          Click to Pledge
        </div>
      </div>
    );
  };

  return (
    <div className="w-full overflow-x-auto pb-8">
      {/* 12x9 Aspect Ratio Container (4:3) */}
      <div className="min-w-[900px] w-full max-w-6xl mx-auto aspect-[4/3] bg-[#f4f1e9] border-8 border-retro-brown shadow-[16px_16px_0px_0px_rgba(58,44,39,1)] p-3 md:p-4 flex flex-col gap-3 relative">
        
        {/* Top Section */}
        <div className="flex gap-3 h-[42%]">
          {/* Large Ad (Left) */}
          <div className="w-1/2 h-full">
            {renderSlot('t-large')}
          </div>
          {/* Medium Ad (Middle) */}
          <div className="w-1/3 h-full">
            {renderSlot('t-med')}
          </div>
          {/* Half-Size Ads (Right Stacked) */}
          <div className="w-1/6 h-full flex flex-col gap-3">
            <div className="h-1/2 w-full">{renderSlot('t-s1')}</div>
            <div className="h-1/2 w-full">{renderSlot('t-s2')}</div>
          </div>
        </div>

        {/* Middle Postage Bar */}
        <div className="h-[12%] bg-[#1a202c] text-white flex items-center justify-between px-6 rounded border-2 border-retro-brown">
          <div className="flex-1 flex items-center gap-4">
            <h2 className="font-display text-4xl md:text-5xl uppercase tracking-tighter text-retro-yellow whitespace-nowrap">
              {city.name} LOCAL
            </h2>
            <div className="font-body text-xs md:text-sm font-bold uppercase leading-tight ml-4 border-l-2 border-white/20 pl-4">
              Check out the hottest<br/>
              promos from local businesses<br/>
              across {city.name}
            </div>
          </div>
          
          <div className="flex items-center gap-4 shrink-0">
            {/* Fake QR Code */}
            <div className="w-16 h-16 bg-white p-1 flex flex-wrap gap-0.5">
              {[...Array(16)].map((_, i) => (
                <div key={i} className={`w-3 h-3 ${Math.random() > 0.5 ? 'bg-black' : 'bg-white'}`}></div>
              ))}
            </div>
            
            {/* Postage Block */}
            <div className="bg-white text-black font-body text-[10px] font-bold text-center border-2 border-black p-1.5 w-32 uppercase leading-tight">
              PRSRT STD<br/>
              ECRWSS<br/>
              U.S. POSTAGE<br/>
              PAID<br/>
              EDDM RETAIL
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex gap-3 h-[42%]">
          {/* Column 1: Stacked Small */}
          <div className="w-1/4 h-full flex flex-col gap-3">
            <div className="h-1/2 w-full">{renderSlot('b-s1')}</div>
            <div className="h-1/2 w-full">{renderSlot('b-s2')}</div>
          </div>
          {/* Column 2: Vertical Tall */}
          <div className="w-1/4 h-full">
            {renderSlot('b-t1')}
          </div>
          {/* Column 3: Vertical Tall */}
          <div className="w-1/4 h-full">
            {renderSlot('b-t2')}
          </div>
          {/* Column 4: Stacked Small */}
          <div className="w-1/4 h-full flex flex-col gap-3">
            <div className="h-1/2 w-full">{renderSlot('b-s3')}</div>
            <div className="h-1/2 w-full">{renderSlot('b-s4')}</div>
          </div>
        </div>

        {/* Side Indicator Badge */}
        <div className="absolute -top-4 -right-4 bg-retro-teal text-white font-display uppercase px-4 py-1 rounded-full border-2 border-retro-brown shadow-sm transform rotate-3 z-30">
          {side} Side
        </div>

      </div>
    </div>
  );
};

export default MailerCard;